//format milliseconds to "00:00" showing minutes and seconds only by default
const formatMsToTime = (value, options = { minute: '2-digit', second: '2-digit' }) => {
  const d = new Date(null);
  d.setHours(0);
  d.setMinutes(0);
  d.setSeconds(0);
  d.setMilliseconds(value);
  return d.toLocaleTimeString('en-GB', options);
};

export default formatMsToTime;
